module.exports = __webpack_public_path__ + "img/banner-2.f83f9a56.jpg";